<template>
    <div>
        <div class="tab-item" >
            <!-- <div class="btn">
            </div> -->
            <!-- <div class="red">
                <span v-if="themeDetail.needVerify == 1">需要场勘</span>
                <span v-else>不需要场勘</span>
                <span>/</span>
                <span v-if="themeDetail.needConstruct == 1">需要搭建</span>
                <span v-else>不需要搭建</span>
            </div>
            <div class="item">
                <div class="left">是否需要SPR</div>
                <div class="right">
                    <span v-if="themeDetail.needSpr == 1">是</span>
                    <span v-else> 否</span>
                </div>
            </div>
            <div class="item">
                <div class="left">是否需要督导打卡</div>
                <div class="right">
                    <span v-if="themeDetail.needSupervisor == 1">是</span>
                    <span v-else> 否</span>
                </div>
            </div>
            <div class="item">
                <div class="left">是否需要转场</div>
                <div class="right">
                    <span v-if="themeDetail.needTransitions == 1">是</span>
                    <span v-else> 否</span>
                </div>
            </div>
            <div class="item">
                <div class="left">装饰点位</div>
                <div class="right">
                    <span v-if="themeDetail.themeDecorates">
                        {{getDecorates(themeDetail.themeDecorates,'、')}}
                    </span>
                    <span v-else>暂无</span>
                </div>
            </div>
            <div class="item" v-if="themeDetail.needTransitions == 1">
                <div class="left">道具数量</div>
                <div class="right">
                    <span>{{ themeDetail.itemQuantity }}</span>
                </div>
            </div>
            <div class="item" v-else>
                <div class="left">
                    <span v-if="themeDetail.pocRelateType == '1'">每售点执行天数</span>
                    <span v-if ="themeDetail.pocRelateType == '2'">每街区执行天数</span>
                    <span v-if ="themeDetail.pocRelateType == '0'">每活动地点执行天数</span>
                </div>
                <div class="right">
                    <span>{{themeDetail.perExecDays}}</span>
                </div>
            </div>
            <div class="item">
                <div class="left">额度信息</div>
                <div class="right right-edu">
                    <div class="item-number" v-for="(item) in detailDTOList" :key="item.regionCode">
                        <span style="margin:0px 5px 0px 0px;">{{getRegionName(item.regionName)}}</span>
                        <span>{{item.totalCountQty}}{{ showText }}</span>
                        <span>（已通过：</span>
                        <span>{{item.passedCountQty}}{{ showText }}</span>
                        <span style="margin:0px 5px;">/</span>
                        <span>审核中：</span>
                        <span>{{item.approvalCountQty}}{{ showText }}</span>
                        <span style="margin:0px 5px;">/</span>
                        <span>未提报：</span>
                        <span>{{item.notReportCountQty}}{{ showText }}</span>
                        <span>）</span>
                    </div>
                </div>
            </div> -->
            <!-- <div class="item-sale2" >
                <div class="div1">
                    售点信息
                </div>
                <div class="div2"  >
                    <PopTable
                    :timeList="timeList"
                    :detailDTOList='detailDTOList'
                    :pocCountMin='pocCountMin'
                    :igniteRuleDTOList='igniteRuleDTOList'
                    :themeDetail="themeDetail"
                    :popData="popData"
                    :popDataitem="popDataitem"
                    :igniteOptions="igniteOptions"
                    :regionCode="regionCode"
                    :queryCondition="queryCondition"
                    :themeBasic="themeBasic"
                    @clickStorename="clickStorename"
                    @activityChanged="onActivityChanged"
                    ></PopTable>
                </div>
            </div> -->
            <!-- <div class="title">提报售点</div> -->
            <PopTable
            :timeList="timeList"
            :detailDTOList='detailDTOList'
            :igniteRuleDTOList='igniteRuleDTOList'
            :popDataitem="popDataitem"
            :igniteOptions="igniteOptions"
            :regionCode="regionCode"
            :queryCondition="queryCondition"
            :themeBasic="themeBasic"
            :routerType="routerType"
            @clickStorename="clickStorename"
            @activityChanged="activityChanged"
            ></PopTable>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import gameplanApi  from '../../../api/gameplan'
    import PopTable from './activity-report-pop-table.vue'
    export default {
      name: 'activity-report-pop-form',
      props: {
        popDataitem:{type:Object, default:()=>{}},
        queryCondition:{type:String},
        igniteOptions:{type:Object, default:()=>{} },
        themeBasic:{type:Object, default:()=>{} },
        regionCode:{type:String, default:'' },
        routerType:{type:String, default:'' },
      },
      components: {
        PopTable
      },
      data () {
        return {
            tableData: [],
            themeDetail:{},
            multipleSelection: [],
            streetArr: [], // 街道数组
            streeIndex:0, // 下标
            searchForm: {
                page: 1,
                pageSize: 5,
                total:0,
                buName:'',
                regionName:''
            },
            isSinglepoint: false, // 单售点
            isManypoint: false, // 多售点
            isEmptypoint: false, // 无售点
            isSingledialog: false, // 单售点
            isManydialog: false, // 多售点
            isEmptydialog: false,// 无售点
            isMask: false,
            searchList: {},
            rowActivityId:'', //点击的活动id
            rowActivityList:[],
            rowBlockname:'',
            rowAreacode:'',
            rowBwContactPerson:'',
            igniteRuleDTOList:[],
            timeList:[],
            detailDTOList: [],
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
        // showText () {
        //     if(this.themeDetail.needTransitions == '1') {
        //         return '场'
        //     } else {
        //         if (this.themeDetail.pocRelateType == '1') {
        //             return '售点'
        //         } else if (this.themeDetail.pocRelateType == '0') {
        //             return '地点'
        //         } else if (this.themeDetail.pocRelateType == '2') {
        //             return '街区'
        //         } else {
        //             return
        //         }
        //     }
        // }
      },
      watch: {},
      created () {
        // if (this.popDataitem.themeLevelCode !== null) {
        //     this.popData = this.popDataitem
        //     this.themeDetail =  this.popDataitem.themeDetail
        //     this.pocCountMin =  this.popDataitem.themeDetail.pocCountMin
        //     this.igniteRuleDTOList =  this.popDataitem.igniteRuleDTOList

        // } else {
        //     this.popData = this.popDataitem.data[0]
        //     this.themeDetail =  this.popDataitem.data[0].themeDetail
        //     this.pocCountMin =  this.popDataitem.data[0].themeDetail.pocCountMin
        //     this.igniteRuleDTOList =  this.popDataitem.data[0].igniteRuleDTOList
        // }
        // if ( this.igniteRuleDTOList == null) {
        //     let mapArr = []
        //     for (let item of this.themeDetail.detailDTOList) {
        //         mapArr.push(item)
        //     }
        //     this.igniteRuleDTOList = [{
        //         'igniteRuleObj':{
        //                 "igniteStatus": [],
        //                 "openStatus": [],
        //                 "channel": [],
        //                 "bizForm": [],
        //                 "subBizForm": null,
        //                 "pocGrade": [],
        //                 "salesVolume": [],
        //                 "pocName": null,
        //                 "themeDetailId": null
        //         },
        //         'igniteMappingDTOList':mapArr
        //     }]
        // }
        // let arr = []
        // for (let item1 of  this.igniteRuleDTOList) {
        //     if (item1.igniteMappingDTOList == null) {
        //         item1.igniteMappingDTOList = [
        //             {
        //                 'regionCode':"",
        //                 'regionName':""
        //             }
        //         ]
        //     }
        //     for (let item2 of item1.igniteMappingDTOList) {
        //         arr.push(
        //             {
        //                 'igniteRuleObj':item1.igniteRuleObj,
        //                 'regionName':item2.regionName,
        //                 'regionCode':item2.regionCode
        //             }
        //         )
        //     }
        // }
        // for (let i = 0; i < arr.length; i++) {
        //     for (let j = i + 1; j < arr.length; j++) {
        //         // 后面数据的若跟前一项数据相同，则重复，需要去除。
        //         if (arr[i].regionCode == arr[j].regionCode) {
        //             arr.splice(j, 1); // 去除后面的相同项
        //             j--;
        //         }
        //     }
        // }
        // this.igniteRuleDTOList = arr
        // for (let item1 of this.popData.curAssignList) {
        //     this.timeList.push({
        //         'assignStartTime':item1.assignStartTime,
        //         'assignEndTime':item1.assignEndTime,
        //         'notReportCountQty':item1.notReportCountQty,
        //         'timeLable':this.getTime(item1.assignStartTime) +' - '+ this.getTime(item1.assignEndTime),
        //         'assignId':item1.assignId,
        //     })
        // }
        // console.log( this.timeList,'timeList');
        // console.log(this.popData,'提报详情--孙popData',this.pocCountMin,'this.pocCountMin',this.themeDetail.pocRelateType,'this.themeDetail.pocRelateType');

        // if (this.themeDetail.pocRelateType == '1') {
        //     this.isSinglepoint = true
        //     this.isManypoint = false
        //     this.isEmptypoint = false

        // } else if (this.themeDetail.pocRelateType == '2') {
        //     this.isSinglepoint = false
        //     this.isManypoint = true
        //     this.isEmptypoint = false
        // } else {
        //     this.isSinglepoint = false
        //     this.isManypoint = false
        //     this.isEmptypoint = true
        // }
        this.init()
        // console.log(this.themeDetail.detailDTOList);
      },
      mounted () {},
      updated () {
      },
      methods: {
        init () {
            this.buildQuotaInfo()
            this.timeList.push({
                'assignStartTime':'',
                'assignEndTime':'',
                // 'notReportCountQty':this.themeDetail.notReportCountQty,
                'notReportCountQty':'',
                'timeLable':'',
                'assignId':'',
            })
        },
        activityChanged () {
            this.$emit('activityChanged')
        },
        buildQuotaInfo() {
          let arr = []
          for (let item of this.popDataitem.themeDetail.detailDTOList) {
              if ( item.totalCountQty > 0) {
                  arr.push(item)
              }
          }
          this.detailDTOList = arr
        },
        getRegionName (name) {
            if (name) {
                return name.split('|')[0] + ':'
            }else {
                return '无'
            }
        },
        getTime (timestamp) {
            if (timestamp === 0 || timestamp == null) {
                return ''
            } else {
                var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
                const Y = date.getFullYear() + '-'
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
                const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
                // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
                // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
                // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
                return Y + M + D
            }
        },
        getDecorates(a,b){
            let arr = a.map((item) => {
                    return item.decorateName
                }).join(b)
            return arr
        },
        clickStorename (row) {
            this.$emit("clickStorename",row)
        },
        async onActivityChanged() {
          // console.log('onActivityChanged')
          const param = {
            themeDetailId: this.themeDetail.themeDetailId
          }
          let res = await gameplanApi.getGamepalnActivityThemeDetailInfo(param)
          if (res.data.resultCode == '0') {
              const themeDetailVO = res.data.resultData.themeDetailVO
              if (themeDetailVO && themeDetailVO.themeDetail && themeDetailVO.themeDetail.detailDTOList) {
                this.$set(this.themeDetail, 'detailDTOList', themeDetailVO.themeDetail.detailDTOList)
                this.buildQuotaInfo()
              }
          }
        }
    }
}
</script>
<style lang="scss" scoped>
.tab-item {
    // padding: 0px 20px 30px 30px;
    padding: 0px 0px 20px 0px;
    // background-color: #FFFFFF;
    color: #101010;
    border-radius: 10px;
    font-size: 14px;
    text-align: left;
    ::v-deep.el-tabs__item.is-active {
        background-color: #FFFFFF;
        color: #409EFF;
    }
    .btn {
        display: flex;
        width: 20%;
        margin-left: 80%;
        height: 42px;
    }
    .red {
        color: #CD1231;
        font-size: 16px;
        font-weight: bold;
        margin-top: -40px;
        height: 32px;
        line-height: 32px;
    }
    .item {
        // height: 32px;
        line-height: 32px;
        display: flex;
        .left {
            font-size: 16px;
            font-weight: bold;
            width: 20%;
        }
        .right {
            flex: 1;
        }
        .right-edu{
            display: flex;
            flex-wrap: wrap;
            .item-number {
                width: 100%;
                // width: 50%;
            }
        }
    }
    .item-sale {
        // .left {
        //     font-size: 16px;
        //     font-weight: bold;
        //     width: 30%;
        //     height: 32px;
        //     line-height: 32px;
        // }
        .left {
            font-size: 16px;
            font-weight: bold;
            height: 52px;
            line-height: 52px;
            display: flex;
            .left-left {
                width: 20%;
                // width: 47.5%;
                line-height: 42px;
            }
            .left-right {
                // width: 90%;
                .searchForm {
                    width: 100%;
                    display: flex;
                    .item {
                        width:150px;
                        ::v-deep .el-input__inner {
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }
                    .item-btn {
                        margin-left: 30px;
                    }
            }
            }
        }
        .right {
            // width: 75%;
            // margin-left: 20%;
            width: 90%;
            margin-left: 5%;
            ::v-deep .el-table th.el-table__cell {
                color: #101010;
                background-color: rgba(232, 232, 232);
            }
            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: #FFFFFF !important;
            }
            .store-name {
                color: #409EFF;
                white-space: nowrap;/*设置不换行*/
                overflow: hidden; /*设置隐藏*/
                text-overflow: ellipsis; /*设置隐藏部分为省略号*/
                cursor: pointer;
            }

            .dialog-bottom {
                position: relative;
                top: 10px;
                text-align: right;
                // ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
                // background-color: #fff;
                // color: #409EFF;
                // border: 1px solid #409EFF
                // }
                // ::v-deep .el-pagination.is-background .el-pager li:hover {
                // color: #409EFF;
                // }
                ::v-deep .el-pagination.is-background .btn-next,
                ::v-deep .el-pagination.is-background .btn-prev{
                    background-color: #FFFFFF;
                    color: #000;
                    // width: 66px;
                    border: 1px solid #C0C4CC;
                    border-radius: 3px;
                }
                ::v-deep .el-pagination.is-background .btn-next:disabled,
                ::v-deep .el-pagination.is-background .btn-prev:disabled,
                ::v-deep .el-pagination.is-background .el-pager li.disabled {
                    color: #C0C4CC;
                }
            }
        }
    }
    .item-sale2 {
        .div1 {
            font-size: 16px;
            font-weight: bold;
            line-height: 42px;
        }
    }
    .title {
        line-height: 40px;
        text-align: left;
        color: #101010;
        font-size: 18px;
        font-weight: 600;
        // margin-bottom: 10px;
    }
}
</style>
